import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import Loader from "../../components/loader/loader";
import "react-responsive-pagination/themes/classic.css";
import ResponsivePagination from "react-responsive-pagination";
import { get } from "../../hooks/services/service";
import { format } from "date-fns";
import { deleteOrderData, downloadFile } from "../../hooks/api/utils";
import CommonModal from "../../components/modal/modal";

const OrderList = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [orderId, setOrderId] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // const [selectUsername, setSelectUsername] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  

  const fetchOrders = async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await get("admin-panel/order-list/", {
        page: pageNum,
      });

      const data = response?.data;

      setOrders(data.results || []);
      setPageCount(Math.ceil(data.count / 10));
    } catch (error) {
      console.error("Failed to fetch orders", error);
    }
    setLoading(false);
    setIsDeleteModalOpen(false);
  };

  useEffect(() => {
    fetchOrders(page);
  }, [page]);

  const handlePageClick = (newPage) => {
    setPage(newPage);
  };

  const handleDownload = () => {
    if (!startDate || !endDate) return;

    const formattedStart = format(new Date(startDate), "dd-MM-yyyy");
    const formattedEnd = format(new Date(endDate), "dd-MM-yyyy");

    const endpoint = "/admin-panel/export-order/";
    const params = {
      start_date: formattedStart,
      end_date: formattedEnd,
    };

    downloadFile(endpoint, params);
  };

  const confirmDelete = async () => {
    if (!orderId) return;
    await deleteOrderData("/admin-panel/order-detail/", orderId);
    setOrderId(null);
    setIsDeleteModalOpen(false);
    setPage(1);
    fetchOrders();
  };
  return (
  
      <div className="rightContent">
        <div className="viewMain">
          <div className="row">
            <div className="col-md-12 bg-white left-col p-2">
              <div className="sortSearchArea d-flex justify-content-between align-items-center mt-4 p-4">
                <h4>Order List</h4>
                <div className="d-flex align-items-center gap-4 width-75 justify-content-end flex-wrap">
                  <div className="width-25 text-start">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="width-25 text-start">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <div className="width-25">
                    <button
                      className="btn btn-outline-secondary mt-4 w-100 p-3"
                      onClick={handleDownload}
                      disabled={!startDate || !endDate}
                    >
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 640 640"
                          width={20}
                          height={20}
                        >
                          <path d="M352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 306.7L246.6 265.3C234.1 252.8 213.8 252.8 201.3 265.3C188.8 277.8 188.8 298.1 201.3 310.6L297.3 406.6C309.8 419.1 330.1 419.1 342.6 406.6L438.6 310.6C451.1 298.1 451.1 277.8 438.6 265.3C426.1 252.8 405.8 252.8 393.3 265.3L352 306.7L352 96zM160 384C124.7 384 96 412.7 96 448L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 448C544 412.7 515.3 384 480 384L433.1 384L376.5 440.6C345.3 471.8 294.6 471.8 263.4 440.6L206.9 384L160 384zM464 440C477.3 440 488 450.7 488 464C488 477.3 477.3 488 464 488C450.7 488 440 477.3 440 464C440 450.7 450.7 440 464 440z" />
                        </svg>
                      </span>{" "}
                      Download
                    </button>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="pateintData">
                    <div className="treatmentData tableTransactionData table-responsive">
                      <table className="table equal-spacing-table">
                        <thead className="tableTransactionHead">
                          <tr>
                            <th>Id</th>
                            <th>Customer Id</th>
                            <th>Customer</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="tableData-color">
                          {orders.length > 0 ? (
                            orders.map((order) => (
                              <tr key={order.id}>
                                <td className="main-grey-text">{order?.id}</td>
                                <td className="main-grey-text">{order?.user_id || '#'}</td>
                                <td>{order?.name}</td>
                                <td>{order?.reccurring_order ? "Recurring order" : `$ ${order.amount.toFixed(2)}`}</td>
                                <td
                                  className={
                                    order.status.toLowerCase() === "completed"
                                      ? "text-green"
                                      : order.status.toLowerCase() === "pending"
                                      ? "main-grey-text"
                                      : "text-primary"
                                  }
                                >
                                  {order.status}
                                </td>
                                <td>
                                  <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-3 action-buttons">
                                    <button
                                      className="bg-transparent border-0"
                                      onClick={() =>
                                        navigate(`/order-detail`, {
                                          state: { orderId: order.id },
                                        })
                                      }
                                      title="view order"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 640 640"
                                        width={20}
                                        height={20}
                                        fill="none"
                                      >
                                        <path
                                          d="M320 96C239.2 96 174.5 132.8 127.4 176.6C80.6 220.1 49.3 272 34.4 307.7C31.1 315.6 31.1 324.4 34.4 332.3C49.3 368 80.6 420 127.4 463.4C174.5 507.1 239.2 544 320 544C400.8 544 465.5 507.2 512.6 463.4C559.4 419.9 590.7 368 605.6 332.3C608.9 324.4 608.9 315.6 605.6 307.7C590.7 272 559.4 220 512.6 176.6C465.5 132.9 400.8 96 320 96zM176 320C176 240.5 240.5 176 320 176C399.5 176 464 240.5 464 320C464 399.5 399.5 464 320 464C240.5 464 176 399.5 176 320zM320 256C320 291.3 291.3 320 256 320C244.5 320 233.7 317 224.3 311.6C223.3 322.5 224.2 333.7 227.2 344.8C240.9 396 293.6 426.4 344.8 412.7C396 399 426.4 346.3 412.7 295.1C400.5 249.4 357.2 220.3 311.6 224.3C316.9 233.6 320 244.4 320 256z"
                                          fill="#6c757d"
                                        />
                                      </svg>
                                    </button>
                                    <button
                                      className="bg-transparent border-0"
                                      onClick={() => {
                                        setOrderId(order.id);
                                        // setSelectUsername(order?.name);
                                        setIsDeleteModalOpen(true);
                                      }}
                                      title="Delete"
                                    >
                                      <img
                                        src="images/deleteGreyIcon.svg"
                                        width="20"
                                        className="img-fluid"
                                        alt="delete"
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No orders found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <ResponsivePagination
                    className="pagination justify-content-center mt-5"
                    current={page}
                    total={pageCount}
                    onPageChange={handlePageClick}
                  />
                </div>
                {/* Delete Confirmation Modal */}
                <CommonModal
                  isOpen={isDeleteModalOpen}
                  onRequestClose={() => {
                    setOrderId(null);
                    // setSelectUsername("");
                    setIsDeleteModalOpen(false);
                  }}
                  title="Confirm Delete"
                >
                  <p className="text-center mb-4">
                    Are you sure you want to delete this order?
                  </p>
                  <div className="d-flex justify-content-end gap-3">
                    <button
                      className="transparent_btn"
                      onClick={() => {
                        setOrderId(null);
                        // setSelectUsername("");
                        // setSelectedUsername("");
                        setIsDeleteModalOpen(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button className="red_btn" onClick={confirmDelete}>
                      Confirm
                    </button>
                  </div>
                </CommonModal>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default OrderList;
